import React, { Component, createRef } from 'react';
import { connect } from 'react-redux';
import './SBRAssignmentDashboardContainer.less';
import { Card, Container, Grid, Icon, Label, Segment, Table } from 'semantic-ui-react';
import { Calendar } from 'react-date-range';
import DGTextbox from 'components/FormControls/Textbox/DGTextbox';
import Formsy from 'formsy-react';
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file
import moment from 'moment';
import { getSBRAssignmentList, unassignRequestFromManager } from 'services/Manager';
import _ from 'lodash';
import { checkManagerAuthorization } from 'helpers/authorization';
import { REQUEST_ASSIGNMENT } from 'constants/FeaturesList';
import {SocketContext} from '../../context/socket';
import { REFRESH_REQUEST_DASHBOARD} from 'constants/socketIOListener';


const initialState = {
  showDatePicker: false,
  date: moment().toDate(),
  momentDate: moment(),
  disableShowButton: false,
  assignmentList: {},
  assignmentEnabled: false,
  fetchedRecords: false
}
class SBRAssignmentDashboardContainer extends Component {
  static contextType = SocketContext
  constructor(props) {
    super(props);
    this.state = initialState;

    document.addEventListener('mousedown', this.handleClickOutside);
    this.txtBoxRef = createRef();
    this.refreshTimer = null;
  }
  async componentDidMount() {
    const socket = this.context
    this.setState({assignmentEnabled: checkManagerAuthorization(REQUEST_ASSIGNMENT , this.props.currentUser)})
    await this.onValidFormSubmit();

    // socket.on(REFRESH_REQUEST_DASHBOARD, (res) => {
    //   this.getAssignmentList();
    // });
  }

  onDateFocus = () => {
    this.setState({ showDatePicker: true });
  }

  onDateChange = (item) => {
    this.setState({ momentDate: moment(item), date: item, showDatePicker: false, disableShowButton: false  });
  }

  handleClickOutside = (e) => {
    //console.log(e.target.parentNode);
    if (this.txtBoxRef.inputRef.current != e.target && !e.target.className.includes("rd") && !e.target.parentNode.className.includes("rd")) {
      this.setState({ showDatePicker: false });
    }

  }

  onDateTextChange = (e, data) => {
    console.log(data.value);
    if (data.value.length == 0) {
      this.setState({ disableShowButton: true });
    }
    else {
      this.setState({ disableShowButton: false });
    }
  }

  onValidFormSubmit= async () => {
    const res = await getSBRAssignmentList(this.state.momentDate.format('MM/DD/YYYY'));
    this.setState({fetchedRecords: true});
    if(res.resStatus == 200){
      const assignmentList = res.data;

      this.setState({assignmentList: this.generateAssignmentListData(assignmentList)});

      if (this.refreshTimer) {
        clearTimeout(this.refreshTimer);
      }


      if(!_.isEmpty(assignmentList)){
        
        this.refreshTimer = setInterval(() => {
          this.getAssignmentList();
        }, 30000);
      }   
    }
  }

  generateAssignmentListData = (assignmentList) => {

    let finalRequestList = {};

        if (assignmentList && assignmentList.length > 0) {

            const allRequestIDs = _.map(assignmentList, al => al.singleBuyerRequestID);

            const unassignedRequestIDs = _.map(_.filter(assignmentList, al => _.isNull(al.assignedToUserID) && !al.isAccepted), ul => ul);

            finalRequestList["0"] = {requests: unassignedRequestIDs};

            const acceptedRequestIDs = _.map(_.filter(assignmentList, al => al.isAccepted), ul => ul);

            finalRequestList["-1"] = {requests: acceptedRequestIDs};

            const uniqUsers = _.map(_.filter(assignmentList, al => !_.isNull(al.assignedToUserID)), al => {
                return {assignedToUserID: al.assignedToUserID, firstName: al.firstName, lastName: al.lastName}
            });

            _.forEach(uniqUsers, user => {
                if (user) {
                    let assignedSBRList = _.map(_.filter(assignmentList, al => al.assignedToUserID == user.assignedToUserID), userRequest => userRequest);
                    const totalRequestCount = assignedSBRList.length;
                    const acceptedRequestCount = _.filter(assignedSBRList, sbr => sbr.isAccepted).length;
                    const fillRate = Math.round((acceptedRequestCount / totalRequestCount) * 100);

                    assignedSBRList = _.map(_.filter(assignmentList, al => al.assignedToUserID == user.assignedToUserID && !al.isAccepted), userRequest => userRequest);
                    finalRequestList[user.assignedToUserID.toString()] = { firstName: user.firstName, lastName: user.lastName, fillRate: fillRate, totalRequestCount: totalRequestCount, requests: assignedSBRList };
                }
            })
        }
        
        return finalRequestList;
  }

  getAssignmentList = async () => {
    const res = await getSBRAssignmentList(this.state.momentDate.format('MM/DD/YYYY'));
    if(res.resStatus == 200){
      const assignmentList = res.data;
      this.setState({assignmentList: this.generateAssignmentListData(assignmentList)});
    }
  }

  onDeleteRequestClick = async (sbrID) => {
    const res = await unassignRequestFromManager(sbrID);
    if(res.resStatus == 200){
       this.onValidFormSubmit();
    }
  }

  applyCssOnLabel = (sbr) => {
    const diff = moment().diff(moment(sbr.initiated), 'seconds');
    if(diff > 0 && diff <= 300 ){
      return 'new';
    }
    else if(sbr.isAccepted){
      return 'accepted';
    }

    return '';
  }


  render() {
    return (
      <Container fluid className="sbr-assignment-dashboard-container">
        <div className="main-page-panel" >
          <div className="content-panel">
            <div className="mobile-header">
              <div className="main-heading">
                Request Assignment Dashboard
              </div>
            </div>
          </div>
          <div className='content-panel'>
            <Formsy onValidSubmit={this.onValidFormSubmit}>
              <Grid>
                <Grid.Row>
                  <Grid.Column width={3}>
                    <div className='date-picker-container'>
                      <DGTextbox innerRef={(node) => {
                        this.txtBoxRef = node;
                      }} onChange={this.onDateTextChange} name="date" placeholder="Choose date" label="Select Date" onFocus={this.onDateFocus}
                        value={this.state.momentDate.format("MM/DD/YYYY")} />
                      <div className='button-container'>
                        <button className='btn-primary' disabled={this.state.disableShowButton}>Show</button>
                      </div>

                      {this.state.showDatePicker && <Calendar onChange={this.onDateChange} date={this.state.date} />}
                    </div>


                  </Grid.Column>
                  
                </Grid.Row>
                <Grid.Row>
                  <Grid.Column width={16}>
                    {!_.isEmpty(this.state.assignmentList) && <Card.Group>
                      {

                        _.map(Object.keys(this.state.assignmentList), usr => {
                          return usr >= 0 && this.state.assignmentList[usr].requests && this.state.assignmentList[usr].requests.length > 0 && _.filter(this.state.assignmentList[usr].requests, r => !r.isAccepted).length > 0 && <Card>
                            <Card.Content>
                              <Card.Header className='card-header'>
                                {usr == 0 && this.state.assignmentList[usr].requests && this.state.assignmentList[usr].requests.length > 0 ? <div>Unassigned</div> : (usr == -1 && this.state.assignmentList[usr].requests && this.state.assignmentList[usr].requests.length > 0 ? <div>Accepted</div> : <div>{this.state.assignmentList[usr].firstName}</div>)}

                                <div>
                                  {usr > 0 && <span>{this.state.assignmentList[usr].fillRate}% / </span>}
                                  <span>{this.state.assignmentList[usr].totalRequestCount}</span>
                                </div>
                              </Card.Header>


                              <Card.Description>

                                {_.map(this.state.assignmentList[usr].requests, req => {
                                  return <Label className={`request-label ${this.applyCssOnLabel(req)}`}>

                                    <a href={`/request/${req.singleBuyerRequestID}`} target="_blank">
                                      <div>{req.singleBuyerRequestID}</div>
                                      <div className='timestamp'>{moment(req.initiated).format("HH:mm")}</div>
                                    </a>
                                    {/*this.state.assignmentEnabled && usr != 0 && <Icon name='delete' onClick={() => this.onDeleteRequestClick(req)} />*/}

                                  </Label>
                                })
                                }
                              </Card.Description>
                            </Card.Content>
                          </Card>

                        })


                      }
                      
                      </Card.Group>
                    
                    }
                      {
                        Object.keys(this.state.assignmentList).includes('-1') && <hr className='separator'/>
                      }
                      {!_.isEmpty(this.state.assignmentList) && <Card.Group>
                      {

                        _.map(Object.keys(this.state.assignmentList), usr => {
                          return usr == -1 && this.state.assignmentList[usr].requests && this.state.assignmentList[usr].requests.length > 0 && <Card>
                            <Card.Content>
                              <Card.Header className='card-header'>
                                <div>Accepted</div>

                                <div>
                                    
                                  <span>{this.state.assignmentList[usr].requests.length}</span>
                                </div>
                              </Card.Header>


                              <Card.Description>

                                {_.map(this.state.assignmentList[usr].requests, req => {
                                  return <Label className={`request-label ${this.applyCssOnLabel(req)}`}>

                                    <a href={`/request/${req.singleBuyerRequestID}`} target="_blank">
                                      <div className='initials'>{req.userInitials}</div>
                                      <div>{req.singleBuyerRequestID}</div>
                                      <div className='timestamp'>
                                        <div>{moment(req.initiated).format("HH:mm")}</div>
                                        <div>{`${moment(req.acceptedOn).diff(moment(req.initiated), "minutes")} mins`}</div>
                                      </div>
                                    </a>
                                    {/*this.state.assignmentEnabled && usr != 0 && <Icon name='delete' onClick={() => this.onDeleteRequestClick(req)} />*/}

                                  </Label>
                                })
                                }
                              </Card.Description>
                            </Card.Content>
                          </Card>

                        })


                      }
                      
                      </Card.Group>
                    
                    }


                    {
                      _.isEmpty(this.state.assignmentList) && this.state.fetchedRecords && <Segment size='big'>No requests found</Segment>
                    }
                     
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Formsy>
          </div>
        </div>
      </Container>

    )
  }
}



function mapStateToProps({ auth }) {
  return {
      currentUser: auth.currentUser
  }
}

export default connect(mapStateToProps)(SBRAssignmentDashboardContainer);


